/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * @returns true if validation passed. An object with the validation id and a message property
 *  inside if failed. Example: { "date": { message: "Something went wrong"}}
 *  IMPORTANT NOTE: When using this validator, make sure that minNum and maxNum are set to 0 and 100
 *  respectively in the formly JSON/input boxes or else validator will not work correctly.
 */


export function percentageValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,
) {
  const model = control.value;
  let errormsg = '';
    if(!(+model >= 0)){
      errormsg =  "Value should be greater than or equal to 0";
    } else if(!(+model <= 100)) {
      errormsg =  "Value should be less than or equal to 100";
    }

  return errormsg
  ? {
      percentage: {
        message: errormsg,
      },
    }
  : null;
}

